export default "__VITE_ASSET__DXdIVsvP__"